// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';

@Component({
  selector: 'e-popup-text',
  templateUrl: './popup-text.component.html',
  styleUrls: ['./popup-text.component.scss'],
})
export class PopupTextComponent {
  @Input() noDivider = false;
}
